import React, {useState} from 'react';
import { BsFillMoonFill } from 'react-icons/bs';
import { ImSun } from "react-icons/im";
import logo from "../assets/logo.png";

export default function Navbar({changeTheme,setTheme}) {
  
  return (
    <nav>
      <div className='brand-container'>
        <div className='brand'>
          <img src={logo} alt='logo' />
        </div>
      </div>
      <div className="links-container">
        <ul className='links'>
          <li>
            <a href='#'>Features</a>
          </li>
          <li>
            <a href='#'>About</a>
          </li>
          <li>
            <a href='#'>Launch</a>
          </li>
          <li>
            <a href='#'>Sign Up</a>
          </li>
          <li>
            <a href='#'>Features</a>
          </li>
          <li onClick={changeTheme}>
            {setTheme == "dark" ? <ImSun className='light' /> : <BsFillMoonFill className='dark' /> }
          </li>
        </ul>
      </div>
    </nav>
  )
}
